import dt from '~/domains/contest/domains/manage/domains/common/testing.const';

import type { FormattedErrors } from '../../../context/utils/formatZodErrors';
import type { FormValues } from '../../../types/FormValues';

import { TableCellSwitch } from './TableCellSwitch';
import type { TableModalColumnType, TableModalRowType } from './types';
import type { TableModalValue } from './types/common';

export function TableRow({
  allErrors,
  allValues,
  columns,
  row,
  sectionKey,
  value = {},
  onChange,
}: {
  allErrors: FormattedErrors;
  allValues: FormValues;
  columns: TableModalColumnType[];
  row: TableModalRowType;
  sectionKey: string;
  value: TableModalValue;
  onChange: (rowKey: string, columnKey: string, newValue: unknown, skipTouched?: boolean) => void;
}) {
  switch (row.type) {
    case 'Base': {
      return (
        <tr data-test-id={dt.table.body.row}>
          {columns.map((column) => (
            <TableCellSwitch
              allErrors={allErrors}
              allValues={allValues}
              cell={row.data[column.key]}
              column={column}
              key={column.key}
              row={row}
              sectionKey={sectionKey}
              value={value}
              onChange={(columnKey: string, newValue: unknown, skipTouched?: boolean) =>
                onChange(row.key, columnKey, newValue, skipTouched)
              }
            />
          ))}
        </tr>
      );
    }
    default: {
      return null;
    }
  }
}
